<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Cuenta</h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">CodigoCuenta</th>
          <th scope="col">NombreCuenta</th>
          <th scope="col">TipoCuenta</th>
          <th scope="col">Nivel</th>
          <th scope="col">PlanContableFechaReg</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="cuenta in datosPaginados" :key="cuenta.idCuenta">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(cuenta.idCuenta)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(cuenta.idCuenta)" title="Editar">edit_square</i></td>
          <td>{{cuenta.codigoCuenta}}</td>
          <td>{{cuenta.nombreCuenta}}</td>
          <td>{{cuenta.tipoCuenta}}</td>
          <td>{{cuenta.nivel}}</td>
          <td>{{getFormattedDate(cuenta.planContableFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteCuenta(cuenta.idCuenta)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idCuenta" class="form-label">IdCuenta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idCuenta" name="idCuenta" v-model="datoCuenta.idCuenta" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Plan Contable -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPlanContable" class="form-label"> Plan Contable</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPlanContable" name="idPlanContable" v-model="datoCuenta.idPlanContable">
                      <option v-for="planContable in planContables" :value="planContable.idPlanContable" :key="planContable.idPlanContable">
                        {{ planContable.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Plan Contable -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="codigoCuenta" class="form-label">CodigoCuenta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="codigoCuenta" name="codigoCuenta" v-model="datoCuenta.codigoCuenta" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombreCuenta" class="form-label">NombreCuenta</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="nombreCuenta" name="nombreCuenta" v-model="datoCuenta.nombreCuenta" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipoCuenta" class="form-label">TipoCuenta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipoCuenta" name="tipoCuenta" v-model="datoCuenta.tipoCuenta" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nivel" class="form-label">Nivel</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nivel" name="nivel" v-model="datoCuenta.nivel" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarCuenta" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditCuenta" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      cuentas : [],
      datoCuenta : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      planContables: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchPlanContables()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.cuentas.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwcuentas/nombre/'+this.nombreBusqueda).then(response=>{
          this.cuentas=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.cuentas.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwcuentas').then(response=>{
      this.cuentas=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.cuentas.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idPlanContable'
        ,'codigoCuenta'
        ,'nombreCuenta'
        ,'tipoCuenta'
        ,'nivel'
      ];
      const requiredFieldsText = [
        'idPlanContable'
        ,'codigoCuenta'
        ,'nombreCuenta'
        ,'tipoCuenta'
        ,'nivel'
      ];
      return validarForm(this.datoCuenta, requiredFields, requiredFieldsText);
    },
    async guardarCuenta(){
      if(this.validarForm() === 1){
        try {
          await api.post('/cuentas', this.datoCuenta)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Cuenta creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditCuenta(){
      if(this.validarForm() === 1){
        try {
          await api.post('/cuentas', this.datoCuenta)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Cuenta creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoCuenta={}
      this.titulo   = 'Crear Cuenta'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idCuenta){
      this.modalWindow = true
      if(idCuenta != null){    
           api.get('/vwcuentas/'+idCuenta).then(resp=>{
          this.datoCuenta = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Cuenta'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idCuenta){
      if(idCuenta != null){
        this.$router.push('/cuentamd/'+idCuenta)
      }
    },
    async deleteCuenta (idCuenta) {
      try{
        await api.delete('/cuentas/'+idCuenta)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchPlanContables() {
      fetch('http://localhost:8080/api/v1/plancontables')
        .then(response => response.json())
        .then(data => {
          this.planContables = data;
        })
        .catch(error => {
          console.error('Error fetching planContables:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
